<!-- PhoneReminderInput.vue -->
<script lang="ts" setup>
import { PhoneReminderType } from '../../Enums/ChoiceEnums';
import { LayoutOrientation } from '../../Enums/UiEnums';
import PhoneInput from './PhoneInput.vue';
import RadioButtonGroup from './RadioButtonGroup.vue';
import { IRadioButtonItem } from './RadioButtonGroupModels';

    const props = defineProps<{
        reminderMethod?: PhoneReminderType,
        overrideNumber?: string
    }>();

    const emits = defineEmits<{
        "update": [],
        "update:reminderMethod": [val:PhoneReminderType|undefined],
        "update:overrideNumber": [val:string|undefined]
    }>();

    const phoneReminderRadioButtonItems : IRadioButtonItem[] = [
            { text: "Home", value: "H" },
            { text: "Work", value: "W"},
            { text: "Other", value: "O"},
            { text: "Override", value: "Z" }
        ];

    function emitReminderMethod(val:PhoneReminderType|undefined)
    {
        emits('update:reminderMethod', val);

        // Reset the override if a non-override is selected
        if (val !== PhoneReminderType.Override && props.overrideNumber?.length)
            emits('update:overrideNumber', "");

        emits('update');

    }
    function emitOverrideNumber(val:string|undefined)
    {
        emits('update:overrideNumber', val);
        emits('update');
    }    
</script>

<template>
    <RadioButtonGroup 
        :modelValue="props.reminderMethod"
        @update:modelValue="emitReminderMethod"
        :items="phoneReminderRadioButtonItems" 
        :layout="LayoutOrientation.Horz" />

    <!-- Override phone number -->
    <PhoneInput 
        v-if="PhoneReminderType.Override === props.reminderMethod"
        :disabled="PhoneReminderType.Override != props.reminderMethod" 
        :modelValue="props.overrideNumber"
        @update:modelValue="emitOverrideNumber"
        title="Override for phone reminder" />
</template>